import { useContext } from 'react'
import { PassContext } from "../../../pass-context"
import dataSelector from '../../data-selector'
import PopupEditor from '../../popup-editor'

import { useState } from "react"
import BwipJs from "@bwip-js/browser"
import FooterImage from './footer-image'

const barcodeWidths = {
  PKBarcodeFormatAztec: 156,
  PKBarcodeFormatQR: 156,
  PKBarcodeFormatPDF417: 250, 
  PKBarcodeFormatCode128: 250,
  undefined: 150
}

const barcodeHeigths = {
  PKBarcodeFormatAztec: 144,
  PKBarcodeFormatQR: 144,
  PKBarcodeFormatPDF417: 60, 
  PKBarcodeFormatCode128: 60,
  undefined: 140
}


const options = {
  PKBarcodeFormatAztec: {
    bcid: 'azteccode',
    scale: 1,
    includetext: false,
    eclevel: 23,
    ecaddchars: 3,
    layers: 8,
    width: 60,
    height: 60,
    padding: 8,
    paddingbottom: 1,
  },
  PKBarcodeFormatQR: {
    bcid: 'qrcode',
    scale: 1,
    includetext: false,
    eclevel: "M",
    ecaddchars: 3,
    layers: 8,
    width: 60,
    height: 60,
    padding: 8,
    paddingbottom: 1,
  },

  PKBarcodeFormatPDF417: {
    bcid: 'pdf417',
    scale: 1,
    includetext: false,
    width: 80,
    height: 20,
    padding: 5,
    paddingbottom: 1,
  },
  PKBarcodeFormatCode128: {
    bcid: 'code128',
    scale: 1,
    width: 80,
    height: 20,
    includetext: false,
    padding: 5,
    paddingbottom: 1,
  }
}

const Barcode = () => {

  const { template, instanceData, scannerInstanceData, isSmartixScannerPass } = useContext(PassContext)
  const barcodeData = dataSelector({ template, instanceData, scannerInstanceData, path: "barcode" })

  try {
    let [img, setImg] = useState(null)
    let [barcodeValue, setBarcodeValue] = useState(null)
    let [barcodeType, setBarcodeType] = useState(null)

    if (isSmartixScannerPass || (barcodeData && barcodeData.message?.length && barcodeData.format !== "NONE")) {
      if (!img || barcodeValue !== barcodeData.message || barcodeType !== barcodeData.format) {
        let canvas = document.createElement('canvas');

        BwipJs.toCanvas(canvas, { ...options[isSmartixScannerPass ? "PKBarcodeFormatQR" : barcodeData?.format], text: barcodeData?.message ?? "dummy barcode value"})

        let barcode = canvas.toDataURL('image/png')

        setImg(barcode)
        setBarcodeType(barcodeData?.format)
        setBarcodeValue(barcodeData?.message)
      }
    } else {
      if (img) {
        setImg(null)
        setBarcodeType(null)
        setBarcodeValue(null)
      }
    }

    return (
      <div className="barcode-wrapper">

        {/* Footer needs to be absolutely positioned just above the barcode. Hence included here. */}
        <FooterImage />

        <div className="flex flex-row w-full justify-center" >
          <PopupEditor title="Barcode" path="barcode" disabled={isSmartixScannerPass}>
            <div className="editable" style={{ minWidth: 150, minHeight: 150, padding:10, marginTop:0, marginBottom:10 }}>
              {barcodeData && barcodeData.format !== "NONE" &&
                <div className="barcode-background">
                  <img src={img} style={{ width: barcodeWidths[isSmartixScannerPass ? "PKBarcodeFormatQR" : barcodeData?.format], height: barcodeHeigths[isSmartixScannerPass ? "PKBarcodeFormatQR" : barcodeData?.format], margin: "auto" }} />
                  <div className="text" style={{minHeight:30}}>{barcodeData?.altText ?? '000-000-000'}</div>
                </div>
              }
            </div>
          </PopupEditor>
        </div>
      </div>
    )
  }

  catch (err) {
    throw err
  }
}

export default Barcode